export { onboardViaDocsAgentWizardSteps } from './onboardviadocs'
import { dotNetCoreWizardStepsNormalizeAgentDownload } from './steps-dotnet-core'
import { dotnetWizardStepsNormalizeAgentDownload } from './steps-dotnet'
import { goWizardStepsNormalizeAgentDownload } from './steps-go'
import { javaWizardStepsNormalizeAgentDownload } from './steps-java'
import { nodeWizardStepsNormalizeAgentDownload } from './steps-node'
import { phpWizardStepsNormalizeAgentDownload } from './steps-php'
import { pythonWizardStepsNormalizeAgentDownload } from './steps-python'
import { rubyWizardStepsNormalizeAgentDownload } from './steps-ruby'

export const stepMappingNormalizeAgentDownload = {
  DOTNET: dotnetWizardStepsNormalizeAgentDownload,
  DOTNET_CORE: dotNetCoreWizardStepsNormalizeAgentDownload,
  GO: goWizardStepsNormalizeAgentDownload,
  JAVA: javaWizardStepsNormalizeAgentDownload,
  NODE: nodeWizardStepsNormalizeAgentDownload,
  PHP: phpWizardStepsNormalizeAgentDownload,
  PYTHON: pythonWizardStepsNormalizeAgentDownload,
  RUBY: rubyWizardStepsNormalizeAgentDownload
}
